import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const YellowTableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Calibri", sans-serif',
  fontSize: "1rem", // smaller text size
}));
const accordionSummaryStyles = {
  width: "92%",
  backgroundColor: "#4276A9",
  color: "#fff",
  height: "1rem",
  minHeight: "48px",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "1rem",
  "&.Mui-expanded": {
    backgroundColor: "#4276A9", // Override the background for expanded state
    minHeight: "48px", // Ensure minHeight is applied in expanded state
    height: "1rem", // Apply the custom height in expanded state as well
    fontFamily: '"Calibri", sans-serif',
  },
};

const CompetenceTable = ({ type }) => {
  let tableContent;
  switch (type) {
    case "ARCHITECT.CLASSA":
      tableContent = (
        <React.Fragment>
          <TableHead>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  The minimum qualifications for an architect shall be the qualifications as provided for in the Architects Act, 1972 for registration{" "}
                  <br /> with the Council of Architecture.
                </Typography>
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Competence: The licensed architect shall be competent to carry out the work related to the building/development permit as given
                  below:
                </Typography>
              </YellowTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <YellowTableCell>1</YellowTableCell>
              <YellowTableCell>
                Preparation of all plans and information connected with building permit except engineering services of multistoried, high-rise, and
                special buildings.
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>2</YellowTableCell>
              <YellowTableCell>
                Issuing certificate of supervision and completion of all buildings pertaining to architectural aspects.
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>3</YellowTableCell>
              <YellowTableCell>
                Preparation of sub-division/layout plans and related information connected with development permit of area up to 1 hectare for
                metro-cities
                <br /> and 2 hectares for other places.
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>4</YellowTableCell>
              <YellowTableCell>
                Issuing certificate of supervision for development of land of area up to 1 hectare for metro-cities and 2 hectares for other places.
              </YellowTableCell>
            </TableRow>
          </TableBody>
        </React.Fragment>
      );
      break;

    case "TOWNPLANNER.CLASSA":
      tableContent = (
        <React.Fragment>
          <TableHead>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Qualification: The minimum qualification for a town planner shall be graduate or post-graduate degree in town and country planning
                  with Associate Membership of the Institute of Town Planners.
                </Typography>
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>NOTE:</YellowTableCell>
              <YellowTableCell>
                However, for land layouts for development permit above 5 hectares in area, landscape architect shall also be associated, and for land
                development
                <br /> infrastructural services for roads, water supplies, sewerage/drainage, electrification, etc. the licensed engineers for
                <br />
                utility services shall be associated.
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Competence: The licensed town planner shall be competent to carry out the work related to the development permit as given below:
                </Typography>
              </YellowTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <YellowTableCell>1</YellowTableCell>
              <YellowTableCell>
                Preparation of plans for land sub-division/layout and related information connected with development permit for all areas.
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>2</YellowTableCell>
              <YellowTableCell>Issuing of certificate of supervision for development of land of all areas.</YellowTableCell>
            </TableRow>
            {/* <TableRow>
              <YellowTableCell>NOTE</YellowTableCell>
              <YellowTableCell>
                However, for land layouts for development permit above 5 hectares in area, landscape architect shall also be associated, and for land
                development
                <br /> infrastructural services for roads, water supplies, sewerage/drainage, electrification, etc. the licensed engineers for
                <br />
                utility services shall be associated.
              </YellowTableCell>
            </TableRow> */}
          </TableBody>
        </React.Fragment>
      );
      break;

    case "SUPERVISOR.CLASSA":
      tableContent = (
        <React.Fragment>
          <TableHead>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Box sx={{ whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word" }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    The minimum qualifications for a supervisor shall be diploma in civil engineering or architectural assistantship, or the
                    qualification in architecture or engineering equivalent to the minimum qualification prescribed for recruitment to non-gazetted
                    service by the Government of India plus 5 years’ experience in building design, construction, and supervision.
                  </Typography>
                </Box>
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Competence: The licensed supervisor shall be competent to carry out the work related to the building permit as given below:
                </Typography>
              </YellowTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <YellowTableCell>1</YellowTableCell>
              <YellowTableCell>
                All plans and related information connected with building permit for residential buildings on plot up to 200 m<sup>2</sup> and up to
                two storeys or 7.5 m in height.
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>2</YellowTableCell>
              <YellowTableCell>Issuing certificate of supervision for residential buildings as per (1) above.</YellowTableCell>
            </TableRow>
          </TableBody>
        </React.Fragment>
      );
      break;
    case "GRADUATECIVILENGINEER.CLASSA":
      tableContent = (
        <React.Fragment>
          <TableHead>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Qualification: The minimum qualifications for an engineer shall be graduate in civil engineering/architectural engineering of
                  recognized Indian or foreign university, or the Corporate Member of Civil Engineering Division/Architectural Engineering Division of
                  the Institution of Engineers (India) or the statutory body governing such profession, as and when established.
                </Typography>
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Competence: The licensed civil engineer shall be competent to carry out the work related to the building/development permit as given
                  below:
                </Typography>
              </YellowTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <YellowTableCell>1</YellowTableCell>
              <YellowTableCell>Preparation of all plans and information connected with building permit.</YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>2</YellowTableCell>
              <YellowTableCell>
                Structural details and calculations of buildings including sub-surface investigation on plot up to 500 sq.m and up to 5 storeys or
                16.0 m in height.
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>3</YellowTableCell>
              <YellowTableCell>Issuing certificate of supervision and completion for all buildings.</YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>4</YellowTableCell>
              <YellowTableCell>Preparation of all service plans and related information connected with development permit.</YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>5</YellowTableCell>
              <YellowTableCell>Issuing certificate of supervision for development of land for all areas.</YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>6</YellowTableCell>
              <YellowTableCell>
                Preparation of subdivision/layout plans and related information connected with development permit of area up to 1 ha for metro-cities,
                and 2 ha for other places.
              </YellowTableCell>
            </TableRow>
          </TableBody>
        </React.Fragment>
      );
      break;
    case "STRUCTURALENGINEER.CLASSA":
      tableContent = (
        <React.Fragment>
          <TableHead>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Qualification: The minimum qualifications for a structural engineer shall be graduate in civil engineering of recognized Indian or
                  foreign university, or Corporate Member of Civil Engineering Division of Institution of Engineers (India), and with minimum 3 years’
                  experience in structural engineering practice with designing and field work.<br></br>
                </Typography>
              </YellowTableCell>
            </TableRow>
            <YellowTableCell>NOTE:</YellowTableCell>
            <YellowTableCell>
              The 3 years’ experience shall be relaxed to 2 years in the case of post-graduate degree of recognized Indian or foreign university in
              the branch of structural engineering. In case of doctorate in structural engineering, the experience required would be one year.
            </YellowTableCell>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Competence: The licensed structural engineer shall be competent to prepare the structural design, calculations and details for all
                  buildings and supervision. In case of buildings having special structural features, as decided by the Authority, which are within
                  the horizontal areas and vertical limits specified in 14.2.2 and 14.2.4 shall be designed only by structural engineers.
                </Typography>
              </YellowTableCell>
            </TableRow>
          </TableHead>
          {/* <TableBody>
            <TableRow>
              <YellowTableCell>NOTE</YellowTableCell>
              <YellowTableCell>
                The 3 years’ experience shall be relaxed to 2 years in the case of post-graduate degree of recognized Indian or foreign university in
                the branch of structural engineering. In case of doctorate in structural engineering, the experience required would be one year.
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>2</YellowTableCell>
              <YellowTableCell>Issuing certificate of supervision for buildings</YellowTableCell>
            </TableRow>
          </TableBody> */}
        </React.Fragment>
      );
      break;
    case "LANDSCAPEARCHITECT.CLASSA":
      tableContent = (
        <React.Fragment>
          <TableHead>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Qualification: The minimum qualification for a landscape architect shall be the bachelor’s or master’s degree in landscape
                  architecture or equivalent from recognized Indian or foreign university.
                </Typography>
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Competence: The licensed landscape Architect shall be competent to carry out the work related to landscape design for building
                  development permit for land areas 5 hectares and above. In case of metro cities, this limit of land area shall be 2 hectares and
                  above.
                </Typography>
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>NOTE:</YellowTableCell>
              <YellowTableCell>
                For smaller areas below the limits indicated above, association of landscape architect may also be considered from the point of view
                of desired landscape development.
              </YellowTableCell>
            </TableRow>
          </TableHead>
          {/* <TableBody>
            <TableRow>
              <YellowTableCell>1</YellowTableCell>
              <YellowTableCell>
                The registered landscape Architect shall be competent to carry out the work related to landscape design for building development
                <br /> permit for land areas 5 hectares and above. In case of metro-cities, this limit of land area shall be 2 hectares and above.{" "}
              </YellowTableCell>
              <YellowTableCell>NOTE</YellowTableCell>
              <YellowTableCell>
                For smaller areas below the limits indicated above, association of landscape architect may also be considered from the point of view
                of desired landscape development.
              </YellowTableCell>
            </TableRow>
          </TableBody> */}
        </React.Fragment>
      );
      break;
    case "URBANDESIGNER.CLASSA":
      tableContent = (
        <React.Fragment>
          <TableHead>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Qualification: The minimum qualification for an urban designer shall be master's degree in urban design or equivalent from
                  recognized Indian or foreign university.
                </Typography>
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Competence: The licensed urban designer shall be competent to carry out the work related to the building permit for urban design for
                  land areas more than 5 hectares and campus area more than 2 hectares. He/She shall also be competent to carry out the work of urban
                  renewal for all areas.
                </Typography>
              </YellowTableCell>
            </TableRow>
            <TableRow>
              <YellowTableCell>NOTE:</YellowTableCell>
              <YellowTableCell>
                For smaller areas below the limits indicated above, association of landscape architect may also be considered from the point of view
                of desired urban design.
              </YellowTableCell>
            </TableRow>
          </TableHead>
          {/* <TableBody>
            <TableRow>
              <YellowTableCell>NOTE</YellowTableCell>
              <YellowTableCell>
                For smaller areas below the limits indicated above, association of landscape architect may also be considered from the point of view
                of desired urban design.
              </YellowTableCell>
            </TableRow>
          </TableBody> */}
        </React.Fragment>
      );
      break;
    case "ENGINEERSUTILITYSERVICES.CLASSA":
      tableContent = (
        <React.Fragment>
          <TableHead>
            <TableRow>
              <YellowTableCell colSpan={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Qualification: The qualification for licensed mechanical engineer (including HVAC), electrical engineer and plumbing engineers for
                  carrying out the work of air-conditioning, heating and mechanical ventilation, electrical installations, lifts, escalators and
                  moving walks and water supply, drainage. sanitation and gas supply installation respectively shall be as given in Part 8 'Building
                  Services' and Part 9 'Plumbing Services' of National Building Code, 2016 or as decided by the Authority considering practices of the
                  National Professional bodies dealing with the specialist engineering services. For multistoried, high-rise, and special buildings
                  the work of building and plumbing services shall be executed under the planning, design, and supervision of competent personnel.
                </Typography>
              </YellowTableCell>
            </TableRow>
          </TableHead>
          {/* <TableBody>
            <TableRow>
              <YellowTableCell>1</YellowTableCell>
              <YellowTableCell>
                The qualification for licensed mechanical engineer (including HVAC), electrical engineer and plumbing engineers for carrying out the
                work of air-conditioning, heating and mechanical ventilation, electrical installations, lifts, escalators and moving walks and water
                supply, drainage. sanitation and gas supply installation respectively shall be as given in Part 8 'Building Services' and Part 9
                'Plumbing Services' of National Building Code, 2016 or as decided by the Authority considering practices of the National Professional
                bodies dealing with the specialist engineering services. For multistoried, high-rise, and special buildings the work of building and
                plumbing services shall be executed under the planning, design, and supervision of competent personnel.
              </YellowTableCell>
            </TableRow>
          </TableBody> */}
        </React.Fragment>
      );
      break;
    default:
      tableContent = null;
  }

  return (
    <TableContainer component={Paper} className="Common-tab-section">
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={accordionSummaryStyles}
        >
          Essential Requirement and Competency
        </AccordionSummary>
        <AccordionDetails>
          <Table aria-label="competence table">{tableContent}</Table>
        </AccordionDetails>
      </Accordion>
    </TableContainer>
  );
};

export default CompetenceTable;
